// extracted by mini-css-extract-plugin
export default {"container":"_1RXTb_J-JHaxRH_hfdrpPC"};